import { useEffect } from 'react';
import { Select } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { getCountriesList, subscribeShopify } from '@/service';
import { localValueMap } from '@/utils/locals';
import { getPrivacyPolicy } from '@/utils/common';

const { Option } = Select;
const EmailSubscribeID: any = {
    eu: '1821358680',
    uk: '499453441',
    de: '1883108763',
    fr: '1245906335',
    it: '2080075461',
    es: '129599037',
};
const EmailSubscribeID_new: any = {
    eu: '1890208037',
    uk: '105959553',
    de: '17911822',
    fr: '1972491857',
    it: '832112264',
    es: '1067045120',
};
const SMSSubscribeID: any = {
    eu: '342060703',
    uk: '274309810',
    de: '1091454408',
    fr: '1452932610',
    it: '544805445',
    es: '593025348',
};
const SITE_ID: any = {
    eu: '4427',
    uk: '4430',
    de: '4425',
    fr: '4428',
    it: '4429',
    es: '4426',
};

export default function SignupPopupMain({ changeStatu, setOptInEmail, isMobile }: any) {
    const { useLang, useState, useRouter, gtm, Link } = useGlobal();
    const { locale, query } = useRouter();
    const { t } = useLang('smssubscribe');
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [showMsg, setShowMsg] = useState('');
    const [prefixCode, setPrefixCode] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [currentCountry, setCurrentCountry] = useState('');
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const phoneRegex = /^[0-9+]{7,20}$/;
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
    const LOCAL_SITES: string[] = ['uk'];

    const onChangeEmail = (v: any) => {
        // 禁止修改传入的邮箱
        if (isSubscribed) {
            return;
        }
        const { value } = v.target;
        setEmail(value.trim());
        if (emailRegex.test(value.trim())) {
            return setShowMsg('');
        }
    };
    const onChangePhone = (v: any) => {
        const { value } = v.target;
        setPhone(value.trim());
        if (phoneRegex.test(value.trim())) {
            return setShowMsg('');
        }
    };

    const handleCheck1 = () => {
        setCheck1(!check1);
        if (!check1 && showMsg) {
            setShowMsg('');
        }
        if (check1 && !showMsg) {
            setShowMsg(t('check'));
        }
    };

    const handleCheck2 = () => {
        setCheck2(!check2);
        if (!check2 && showMsg) {
            setShowMsg('');
        }
        if (check2 && !showMsg) {
            setShowMsg(t('check'));
        }
    };

    const handleSubmit = async () => {
        if (!email) {
            return setShowMsg(t('tip_email'));
        }
        if (!emailRegex.test(email)) {
            return setShowMsg(t('tip_email'));
        }
        if (!phone) {
            return setShowMsg(t('tip_phone'));
        }
        if (!phoneRegex.test(phone)) {
            return setShowMsg(t('tip_phone'));
        }
        if (!check1 || !check2) {
            return setShowMsg(t('check'));
        }
        setShowMsg('');
        try {
            // 已订阅邮箱
            if (!isSubscribed) {
                const data = {
                    email: email,
                    contactListId: EmailSubscribeID_new[locale],
                    fields: [
                        // C端用户字段
                        {
                            id: '5910',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        // 站点字段
                        {
                            id: SITE_ID[locale],
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        // 2024-01-30 新增
                        // Mobile SMS Opt-In
                        {
                            id: '3511',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        // Mobile
                        {
                            id: '37',
                            type: 'text',
                            value: prefixCode + phone,
                            overwrite: true,
                        },
                        // Opt-In
                        {
                            id: '31',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        // Email
                        {
                            id: '3',
                            type: 'text',
                            value: email,
                            overwrite: true,
                        },
                        // Shopify Tags
                        {
                            id: '4273',
                            type: 'text',
                            value: 'SMS Sub',
                            overwrite: false,
                        },
                    ],
                };
                const res = await subscribeShopify(data, locale, {
                    sector_name: t('title'),
                    entry_position: 1,
                });
            }
            // 订阅SMS
            const dataSMS = {
                email: email,
                contactListId: SMSSubscribeID[locale],
                fields: [
                    // SMS
                    {
                        id: '37',
                        type: 'text',
                        value: prefixCode + phone,
                        overwrite: true,
                    },
                    // SMS订阅 true 1 false 2
                    {
                        id: '3511',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    // C端用户字段
                    {
                        id: '5910',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    // 站点字段
                    {
                        id: SITE_ID[locale],
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    // Campaign字段
                    // {
                    //     id: '7596',
                    //     type: 'multiple',
                    //     value: [9],
                    //     overwrite: false,
                    // },
                ],
            };
            const res = await subscribeShopify(dataSMS, locale, {
                sector_name: t('title'),
                entry_position: 1,
            });
            if (res?.code === '0') {
                if (!isSubscribed) {
                    setEmail('');
                }
                setOptInEmail(check2);
                setPhone('');
                setShowMsg('');
                changeStatu(2);
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    const getCountries = async () => {
        try {
            const res: any = await getCountriesList({
                page: 1,
                size: 250,
            });
            if (res?.code === '0') {
                const cl = res?.data?.content?.map((item: any) => ({
                    key: item.id,
                    text: item.name,
                    phoneCode: item.phoneCode,
                }));
                const arr = [...countryList, ...cl];
                setCountryList(arr);
                const lc = locale === 'eu' ? 'de' : locale;
                const curCountry = arr?.find((list: any) => {
                    return (
                        localValueMap[lc]?.region?.toLowerCase() === list?.text?.toLowerCase() ||
                        localValueMap[lc]?.regionForWarranty?.toLowerCase() === list?.text?.toLowerCase()
                    );
                });
                setCurrentCountry(curCountry.text);
                setPrefixCode(curCountry?.phoneCode);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const onCountryChange = (value: any) => {
        const target = countryList.filter((item: any) => item.text === value);
        setCurrentCountry(value);
        if (target?.length) {
            const [item] = target;
            setPrefixCode(item.phoneCode);
        }
    };

    useEffect(() => {
        getCountries().catch();
        setIsSubscribed(!!query?.email);
        setEmail(query?.email);
    }, []);

    return (
        <div className={`signup-popup-main ${css['signup-popup-main']} ${isMobile ? 'signup-popup-main-h5' : 'signup-popup-main-pc'}`}>
            <div className="banner">
                <NextImage
                    src={require(`@publicLocal/sms-subscribe/${isMobile ? 'h5' : 'pc'}/kv${
                        EU_SITES?.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''
                    }.jpg`)}
                    alt={t('title')}
                />
            </div>
            <div className="popup-content">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="control">
                    <input
                        type="text"
                        disabled={isSubscribed}
                        className="input input-email"
                        value={email}
                        onChange={onChangeEmail}
                        placeholder={t('placeholder_email')}
                    />
                    <Select
                        className="country"
                        optionFilterProp="children"
                        onChange={onCountryChange}
                        showSearch
                        dropdownClassName="ef-select-item"
                        value={currentCountry}
                    >
                        {countryList?.map((item: any, index: number) => (
                            <Option value={item.text} key={index}>
                                {item.text}
                            </Option>
                        ))}
                    </Select>
                    <div className="phone-wrap">
                        <span className="prefix-code">{prefixCode}</span>
                        <input type="text" className="input input-phone" value={phone} onChange={onChangePhone} placeholder={t('placeholder_phone')} />
                    </div>
                    <button className="subscribe" onClick={handleSubmit}>
                        {t('btn')}
                    </button>
                </div>
                {showMsg && <p className="error-msg">{showMsg}</p>}
                <div className="agreement">
                    <input type="checkbox" className="agree-check" id="agree1" checked={check1} onChange={handleCheck1} />
                    <label htmlFor="agree1" className="agree-label">
                        {t.rich('agree_1', {
                            a1: (text: string) => (
                                <Link className="link" href={getPrivacyPolicy(locale)}>
                                    {text}
                                </Link>
                            ),
                            a2: (text: string) => (
                                <Link className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`}>
                                    {text}
                                </Link>
                            ),
                        })}
                    </label>
                </div>
                <div className="agreement">
                    <input type="checkbox" className="agree-check" id="agree2" checked={check2} onChange={handleCheck2} />
                    <label htmlFor="agree2" className="agree-label">
                        {t('agree_2')}
                    </label>
                </div>
            </div>
        </div>
    );
}
